export default "__VITE_ASSET__FzM67WQx__"